import { axiosReq } from "utils";
import { ChallengeSetupActions } from "./ChallengeSetupReducer";
import { toast } from "sonner";
import { getUser } from "../Profile/ProfileActions";

//get challenge types
export const getChallengeTypes = () => {
  return async (dispatch) => {
    try {
      dispatch(ChallengeSetupActions.getChallengeTypesRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/challengeType`,
        withCredentials: true,
      });
      dispatch(ChallengeSetupActions.getChallengeTypesSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeSetupActions.getChallengeTypesError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//get currencies
export const getCurrencies = () => {
  return async (dispatch) => {
    try {
      dispatch(ChallengeSetupActions.getCurrenciesRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/currency`,
        withCredentials: true,
      });
      dispatch(ChallengeSetupActions.getCurrenciesSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeSetupActions.getCurrenciesError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//check promo
export const checkPromoFunction = (getToken, code, params) => {
  return async (dispatch) => {
    try {
      const token = await getToken();
      dispatch(ChallengeSetupActions.checkPromoRequest());
      const response = await axiosReq({
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: `${process.env.REACT_APP_BACKEND_URL}/promo/${code}`,
        withCredentials: true,
        params: params,
      });
      dispatch(ChallengeSetupActions.checkPromoSuccess(response?.data));
      toast.success("Promo Code Applied Successfully", {
        autoClose: 2000,
        className: "bg-green-opacity text-green",
      });
    } catch (error) {
      toast.error(error.response?.data.message, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
      dispatch(
        ChallengeSetupActions.checkPromoError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//get platforms
export const getPlatforms = () => {
  return async (dispatch) => {
    try {
      dispatch(ChallengeSetupActions.getPlatformsRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/platform`,
        withCredentials: true,
      });
      dispatch(ChallengeSetupActions.getPlatformsSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeSetupActions.getPlatformsError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//get challenge details
export const getChallengeDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(ChallengeSetupActions.getChallengeInfoRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/challengeType/details`,
        withCredentials: true,
        params: data,
      });
      dispatch(ChallengeSetupActions.getChallengeInfoSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeSetupActions.getChallengeInfoError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//create challenge
export const createChallenge = (getToken, data, navigate) => {
  return async (dispatch) => {
    try {
      const token = await getToken();
      dispatch(ChallengeSetupActions.createChallengeRequest());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/challenge`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data,
      });
      dispatch(ChallengeSetupActions.createChallengeSuccess(response?.data));
      localStorage.removeItem("challengeTypeId");
      localStorage.removeItem("currencyId");
      localStorage.removeItem("platformId");
      localStorage.removeItem("balanceId");
      localStorage.removeItem("accountTypeId");

      toast.success("Challenge Created Successfully", {
        autoClose: 2000,
        className: "bg-green-opacity text-green",
      });
      dispatch(getUser(getToken));
      if (navigate) navigate("/");
    } catch (error) {
      localStorage.removeItem("challengeTypeId");
      localStorage.removeItem("currencyId");
      localStorage.removeItem("platformId");
      localStorage.removeItem("balanceId");
      localStorage.removeItem("accountTypeId");
      toast.error(error.response?.data.message, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
      dispatch(
        ChallengeSetupActions.createChallengeError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//create draft
export const createDraft = (getToken, data) => {
  return async (dispatch) => {
    try {
      const token = await getToken();
      dispatch(ChallengeSetupActions.createDraftRequest());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/challenge/draft`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data,
      });
      dispatch(ChallengeSetupActions.createDraftSuccess(response?.data));
    } catch (error) {
      toast.error(error.response?.data.message);
      dispatch(
        ChallengeSetupActions.createDraftError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//continue draft
export const continueDraft = (getToken, data, navigate) => {
  return async (dispatch) => {
    try {
      const token = await getToken();
      dispatch(ChallengeSetupActions.continueDraftRequest());
      const response = await axiosReq({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/challenge/draft`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data,
      });
      dispatch(ChallengeSetupActions.continueDraftSuccess(response?.data));
      toast.success("Challenge Created Successfully", {
        autoClose: 2000,
        className: "bg-green-opacity text-green",
      });
    } catch (error) {
      toast.error("Payment Initiation Failed", {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
      dispatch(
        ChallengeSetupActions.continueDraftError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//get addons
export const getAddons = (id) => {
  return async (dispatch) => {
    try {
      dispatch(ChallengeSetupActions.getAddonsRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/addon/${id}`,
        withCredentials: true,
      });
      dispatch(ChallengeSetupActions.getAddonsSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeSetupActions.getAddonsError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//init payable payment
export const initPayablePayment = (getToken, data) => {
  return async (dispatch) => {
    try {
      const token = await getToken();
      dispatch(ChallengeSetupActions.initPayablePaymentRequest());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/payissa/payment`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: data,
      });
      dispatch(ChallengeSetupActions.initPayablePaymentSuccess(response?.data));
    } catch (error) {
      console.log(error, "error");
      toast.error("Payment Initiation Failed", {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
      dispatch(
        ChallengeSetupActions.initPayablePaymentError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const createWelcomeDraft = (data) => {
  return async (dispatch) => {
    try {
      dispatch(ChallengeSetupActions.createDraftRequest());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/challenge/startDraft`,
        withCredentials: true,

        data,
      });
      dispatch(ChallengeSetupActions.createDraftSuccess(response?.data));
    } catch (error) {
      toast.error(error.response?.data.message);
      dispatch(
        ChallengeSetupActions.createDraftError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//check promo
export const checkWelcomePromoFunction = (code, params) => {
  return async (dispatch) => {
    try {
      dispatch(ChallengeSetupActions.checkPromoRequest());
      const response = await axiosReq({
        method: "get",

        url: `${process.env.REACT_APP_BACKEND_URL}/promo/start/${code}`,
        withCredentials: true,
        params: params,
      });
      dispatch(ChallengeSetupActions.checkPromoSuccess(response?.data));
      toast.success("Promo Code Applied Successfully", {
        autoClose: 2000,
        className: "bg-green-opacity text-green",
      });
    } catch (error) {
      toast.error(error.response?.data.message, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
      dispatch(
        ChallengeSetupActions.checkPromoError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//clear promo
export const clearPromo = () => {
  return async (dispatch) => {
    dispatch(ChallengeSetupActions.clearPromo());
  };
};

//affiliate tracking
export const affiliateTracking = (data) => {
  return async (dispatch) => {
    try {
      dispatch(ChallengeSetupActions.affiliateTrackingRequest());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/partner/traffic`,
        withCredentials: true,

        data,
      });
      dispatch(ChallengeSetupActions.affiliateTrackingSuccess(response?.data));
    } catch (error) {
      toast.error(error.response?.data.message || "Something went wrong", {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
      dispatch(
        ChallengeSetupActions.affiliateTrackingError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//clear states
export const clearStates = () => {
  return async (dispatch) => {
    setTimeout(() => {
      dispatch(ChallengeSetupActions.clearStates());
    }, 3000);
  };
};
